import { render, staticRenderFns } from "./CRTokenRemove.vue?vue&type=template&id=fac1c9b0&scoped=true&"
import script from "./CRTokenRemove.vue?vue&type=script&lang=js&"
export * from "./CRTokenRemove.vue?vue&type=script&lang=js&"
import style0 from "./CRTokenRemove.vue?vue&type=style&index=0&id=fac1c9b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac1c9b0",
  null
  
)

export default component.exports